// extracted by mini-css-extract-plugin
export default {"list":"ZooList_list__U4TiP"};